import { getOrgAccount } from "@/actions/accountActions";
import type { OrgAccount } from "@/api/orgAccountApi";
import type { AuthTokenData } from "@/auth";
import { BaseStore, atomRequired } from "@deputy-ai/common/jotai";
import { atom } from "jotai";

export { type OrgAccount } from "@/api/orgAccountApi";

export class AuthStore extends BaseStore {
  tokenData = atom<AuthTokenData | undefined>(undefined);

  account = atom<OrgAccount | undefined>(undefined);

  accountUid = atom((get) => get(this.tokenData)?.accountUid);

  orgUid = atom((get) => get(this.tokenData)?.orgUid);

  requiredOrgUid = atomRequired(this.orgUid);

  setTokenData(token?: AuthTokenData) {
    this.set(this.tokenData, token);
  }

  setAccount(account?: OrgAccount) {
    this.set(this.account, account);
  }

  async loadAccount() {
    const accountUid = this.get(this.accountUid);
    if (!accountUid) {
      throw new Error("orgUid or accountUid is not available");
    }
    const response = await getOrgAccount({
      accountUid,
    });

    this.set(this.account, response.data?.orgAccount);
  }
}

export const authStore = new AuthStore();
